import React from "react";
const RenderStars=({rating,className}:{rating:any,className?:any})=>{
    const fullStars = Math.floor(rating);
    const halfStars = rating % 1 !== 0;
    const emptyStars = 5 - fullStars - (halfStars ? 1 : 0);

    return (
        <>
            {[...Array(fullStars)].map((_, i) => (
                <i key={`full-${i}`} className= {`fa fa-star text-yellow-500 ${className}`}/>
            ))}
            {halfStars && <i className={`fa fa-star-half-alt text-yellow-500  ${className}`} />}
            {[...Array(emptyStars)].map((_, i) => (
                <i key={`empty-${i}`} className= {`fa fa-star text-gray-300  ${className}`} />
            ))}
        </>
    );
}

export default RenderStars;